import { LocationSubheader } from "./subheader"
import "./background.scss"
import "./breadcrumbs.scss"
import "./header.scss"
import "./issued.scss"
import "./index.scss"

require.context("./static", true, /\.jpg$/)

export { LocationSubheader }
